<template>
  <div class="about mt-4">
    {{status}}
  </div>
</template>

<script>
 import StatusApi from '../generatedApiClient/api/endpoints/StatusApi';
 let apiInstance = new StatusApi();


export default {
  name: "Status",
  components: {
  },
  data() {
    return {
      status: ''
    };
  },
  mounted() {
    apiInstance.getStatus().then((data) => {
      this.status = JSON.stringify(data);
      console.log("[mounted] [API] [getStatus] [OK] status response = " + JSON.stringify(data));
    }, (error) => {
      console.log("[mounted] [API] [getStatus] [ERROR]", error);
      console.error(error);
    });
  }
};
</script>
<style scoped>
</style>